import React from 'react';
import { t } from 'Src/i18n';

const NoticeEstimationCostProposal = ({ notice }: { notice: string }) => {
  return (
    <div className="flex justify-center">
      <span
        className="rounded-24 border-0 bg-lightSand px-30 py-5 text-center text-16 font-bold text-sienna"
        data-testid="noticeEstimationCost"
      >
        {notice}
      </span>
    </div>
  );
};

export const PriceEstimationCostProposal = ({
  total,
  totalWithoutDiscount,
  productId,
}: {
  total: string;
  totalWithoutDiscount: string;
  productId?: string;
}) => {
  if (!total || !totalWithoutDiscount) {
    return null;
  }

  const isSAFC = productId === 'SAFC';
  return (
    <div className="my-30">
      <div>
        <div className="flex justify-center text-center text-16">
          <span>{t('prebookingForm.estimativePrice.confirmation')}</span>
        </div>
        <div className="mb-30 flex justify-center">
          <span
            className="m-5 self-center text-center text-16 font-bold text-sienna line-through"
            data-testid="totalWithoutDiscount"
          >
            {totalWithoutDiscount}
          </span>
          <span
            className="m-5 text-center font-sans text-20 font-bold underline"
            data-testid="totalWithDiscount"
          >
            {total}
          </span>
        </div>
        {isSAFC ? (
          <NoticeEstimationCostProposal
            notice={t('prebookingForm.estimativePrice.safcEstimativePrice') || ''}
          />
        ) : (
          <NoticeEstimationCostProposal
            notice={t('prebookingForm.estimativePrice.reinsuranceInformation') || ''}
          />
        )}
      </div>
    </div>
  );
};
